<template>
  <div id="app">
    <pageheader
      ref="header"
      :class="{ 'ios-guide-header': $route.name === 'iosAppGuide' }"
    />
    <router-view :key="key" />
    <!-- <div
      class="app-footer"
      v-if="$route.path !== '/download' && !$route.path.includes('liveDetails')"
    >
      <pagefooter />
    </div> -->
    <download-tip
      v-if="
        !$route.path.includes('liveDetails') && $route.name !== 'iosAppGuide'
      "
    />
    <tip-box />
    <main-tain v-if="maintainBox" :maintainWords="maintainWords" />
    <el-backtop :right="42" :bottom="100" />
  </div>
</template>

<script>
import mainTain from "./base/mainTain";
import pageheader from "./base/header";
// import pagefooter from "./base/footer";
import downloadTip from "./base/downloadTip";
import tipBox from "./base/tipBox";
import { mapMutations } from "vuex";
import { Backtop } from "element-ui";

const HOME_CONFIG_CACHE_KEY = "pc-home-config-cache";
const HOME_CONFIG_CACHE_TTL = 24 * 60 * 60 * 1000;

// import Socket from './socket'
// import socketMixin from './mixins/socket'
export default {
  name: "App",
  components: {
    pageheader,
    // pagefooter,
    downloadTip,
    tipBox,
    mainTain,
    "el-backtop": Backtop,
  },
  data() {
    return {
      maintainWords: "",
      maintainBox: false,
    };
  },
  // mixins: [socketMixin],
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + new Date()
        : this.$route.name + new Date();
    },
    message() {
      return this.$store.state.message;
    },
  },
  watch: {
    message(val) {
      if (val) {
        this.$EventBus.$emit("hide", val);
      }
    },
    $route(to, from) {
      // localStorage.setItem('gamingRoute',to.path);
      document.documentElement.scrollTop = 0;
      if (to.matched[0].path === "/liveDetails/:id") {
        this.$refs.header.goLiveDetails();
      } else {
        this.$refs.header.goOtherP();
      }
      if (to.path === "/" || to.path === "/pc/") {
        this.$refs.header.shouyeSpeSty();
        this.$refs.header.adShow = true;
      } else {
        this.$refs.header.cancelShouye();
        this.$refs.header.adShow = false;
      }
    },
  },
  created() {
    let skinName = window.localStorage.getItem("skin") || "warning";
    let root = document.documentElement;
    if (skinName === "warning") {
      root.className = "global__style--primary";
    } else {
      root.className = "global__style--primary";
    }
    this.restoreHomeConfigCache();
    this.checkMaintain();
    // if(localStorage.getItem('gamingRoute')){
    //   this.$router.replace(localStorage.getItem('gamingRoute'));
    // }
    // this.$store.dispatch('actionsDownloadImg');//每次刷新都获取一下app下载二维码
    if (localStorage.getItem("token")) {
      //当刷新页面调用获取个人信息的方法赋值给vuex里面的userInfo
      this.$store.dispatch("actionsUserInfo");
    }
    // this.$EventBus.$on('outlive', this.outlive)
  },
  mounted() {
    if (this.$route.path === "/" || this.$route.path === "/pc/") {
      this.$refs.header.shouyeSpeSty();
      this.$refs.header.adShow = true;
    } else {
      this.$refs.header.cancelShouye();
      this.$refs.header.adShow = false;
    }
  },
  // beforeDestroy() {
  //   if (this.socket) {
  //     this.socket.socketClose()
  //   }
  // },
  methods: {
    ...mapMutations(["setSportType"]),
    applyHomeConfig(info, { fromCache = false } = {}) {
      if (!info || typeof info !== "object") return;
      if (!fromCache && info.maintain_switch == "1") {
        this.maintainBox = true;
        this.maintainWords = info.maintain_tips;
      }
      localStorage.setItem(
        "infofold",
        info.chat_visitor_record_infofold__switch
      );
      localStorage.setItem("visitor_chat", info.chat_visitor_chat__switch);
      localStorage.setItem(
        "live_teidan_show__switch",
        info.live_teidan_show__switch
      );
      this.$store.commit(
        "setInfofold",
        info.chat_visitor_record_infofold__switch
      );
      this.$store.commit("setVisitorChat", info.chat_visitor_chat__switch);
      this.$store.commit("setSocketUrl", info.domain_websocket_chat);
      this.$store.commit("setDownloadImg", info);
      this.$store.commit("setConfigMutation", info);
      this.setSportType(Array.isArray(info.liveclass) ? info.liveclass : []);
    },
    restoreHomeConfigCache() {
      try {
        const cached = JSON.parse(
          localStorage.getItem(HOME_CONFIG_CACHE_KEY) || "null"
        );
        if (
          cached &&
          cached.data &&
          Date.now() - Number(cached.ts || 0) < HOME_CONFIG_CACHE_TTL
        ) {
          this.applyHomeConfig(cached.data, { fromCache: true });
        }
      } catch (error) {
        localStorage.removeItem(HOME_CONFIG_CACHE_KEY);
      }
    },
    checkMaintain() {
      //检查网站是否再维护中
      this.$axios
        .post("/", {
          service: "Home.getConfig",
        })
        .then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            const info = res.info && res.info[0];
            if (!info) return;
            this.applyHomeConfig(info);
            localStorage.setItem(
              HOME_CONFIG_CACHE_KEY,
              JSON.stringify({ ts: Date.now(), data: info })
            );
          }
        })
        .catch(() => {});
    },
    // outlive(data) {
    //   // if (this.socket) this.socket.removeListen()
    //   // this.socket = new Socket({
    //   //   url: "ws://139.159.182.233:9511",
    //   //   name: "outlive",
    //   //   receive: (data) => {
    //   //     switch (data.code) {
    //   //       case 2000:
    //   //         this.socket.removeListen();
    //   //         break
    //   //     }
    //   //   }
    //   // }, true)
    //   this.socket.subSend(data)
    // }
  },
};
</script>
<style>
.gift-fade-enter {
  transform: translateX(-100%);
}
.gift-fade-enter-to {
  transform: translateX(0);
}
.gift-fade-leave {
  transform: translateY(0);
}
.gift-fade-leave-to {
  transform: translateY(-100%);
}
.app-footer {
  animation: change 0.3s ease-in forwards;
  opacity: 0;
}
@keyframes change {
  90% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.barrageDivClass {
  position: absolute;
  top: 0;
  display: block;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap;
}
@media (max-width: 900px) {
  #app .header.ios-guide-header {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue